
import { CommonOktaStyling } from './CommonStyling';
import classess from './OktaSignInWidget.scss';
import { maskEmail } from './oktaUtils';

function OktaSelectScreenCssHelper(securityIcon) {

  const verifyMessage = document.createElement('div');
  if (!document.querySelector('.verify-message')) {
    verifyMessage.className = 'verify-message';
    verifyMessage.style.display = 'flex';
    verifyMessage.style.alignItems = 'center';

    const verifyImage = document.createElement('div');
    verifyImage.style.backgroundImage = `url(${securityIcon})`;
    verifyImage.style.height = '32px';
    verifyImage.style.width = '36px';
    verifyImage.style.marginRight = '10px';

    const verifyContent = document.createElement('div');
    verifyContent.textContent = 'Verify it’s you with a security method';
    verifyContent.style.fontWeight = CommonOktaStyling.FONT_WEIGHT_BOLD;
    verifyContent.style.color = CommonOktaStyling.TEXT_COLOR_GREY;
    verifyContent.style.textAlign = CommonOktaStyling.TEXT_ALIGN_LEFT;
    verifyContent.style.fontSize = CommonOktaStyling.FONT_SIZE_SL;
    verifyContent.style.lineHeight = CommonOktaStyling.LINE_HEIGHT_S;
    verifyContent.classList.add(classess.textSizeSM);
    verifyMessage.appendChild(verifyImage);
    verifyMessage.appendChild(verifyContent);

    const selectMessage = document.querySelector('#okta-sign-in .siw-main-view .okta-form-subtitle');
    if (selectMessage) {
      selectMessage.parentNode.insertBefore(verifyMessage,selectMessage);
    }

    const refElement = document.querySelector('.o-form-content > .identifier-container');
    if (refElement) {
      refElement.style.marginTop = CommonOktaStyling.MARGIN_SM;
      refElement.style.fontSize = CommonOktaStyling.FONT_SIZE_SL;
      refElement.classList.add(classess.humanLogo,classess.textSizeSM);
    }
    const emailTitle=document.querySelector('.o-form-content > .identifier-container > .identifier');
    if (emailTitle) {
      emailTitle.classList.add(classess.textSizeSM,classess.textGrey);
    }
  }

  const buttons = document.querySelectorAll('.authenticator-button > .button.link-button');
  if (buttons) {
    buttons.forEach((button, index) => {
      button.style.display = 'block';
      button.style.textAlign = CommonOktaStyling.TEXT_ALIGN_CENTER;
      button.style.fontWeight = CommonOktaStyling.FONT_WEIGHT_BOLD;
      button.style.background = CommonOktaStyling.BACKGROUND_COLOR_BUTTON;
      button.style.color = CommonOktaStyling.TEXT_COLOR_BLACK;
      button.style.borderRadius = CommonOktaStyling.BORDER_RADIUS;
      button.style.textTransform = CommonOktaStyling.TEXT_TRANSFORM_UPPERCASE;
      button.classList.add(classess.textBtnSizeS,classess.selectButton);
    });
  }
}

export default function OktaSelectScreenCss(emailIcon, phoneIcon, securityIcon) {
  
  const selectMessage = document.querySelector('#okta-sign-in .siw-main-view .okta-form-subtitle');
  if (selectMessage) {
    selectMessage.style.margin = CommonOktaStyling.MARGIN_NONE;
    selectMessage.style.fontWeight = CommonOktaStyling.FONT_WEIGHT_SEMI_BOLD;
    selectMessage.classList.add(classess.textSizeSM,classess.textGrey);
  }

  const fieldTitle= document.querySelector('#okta-sign-in h3');
  if (fieldTitle) {
    fieldTitle.classList.add(classess.textSizeXS,classess.textGrey);
  }

  const authenticatorRow = document.querySelectorAll('.list-content > .authenticator-row.clearfix');
  const authenticatorDescription = document.querySelectorAll('.authenticator-row.clearfix > .authenticator-description');
  const selectButton = document.querySelectorAll('.authenticator-description > .authenticator-button');
  if (authenticatorRow) {
    authenticatorRow.forEach((el, index) => {
      authenticatorRow[index].style.margin = CommonOktaStyling.MARGIN_NONE;
      authenticatorDescription[index] && authenticatorDescription[index].removeChild(selectButton[index]);
      authenticatorRow[index].parentNode.insertBefore(selectButton[index], authenticatorRow[index].nextSibling);
      selectButton[index].style.margin = CommonOktaStyling.MARGIN_SM_NONE;
      selectButton[index].classList.add(classess.textSizeS);
    });
  }

  if (authenticatorDescription) {
    authenticatorDescription.forEach((element, index) => {
      element.style.fontSize = CommonOktaStyling.FONT_SIZE_SM;
      element.style.fontWeight = CommonOktaStyling.FONT_WEIGHT_BOLD;
      element.style.color = CommonOktaStyling.TEXT_COLOR_BLACK;
    });
  }

  OktaSelectScreenCssHelper(securityIcon);

  const emailElement = document.querySelector('#okta-sign-in.auth-container .mfa-okta-email');
  if (emailElement) {
    emailElement.style.backgroundImage = `url(${emailIcon})`;
    emailElement.style.border = CommonOktaStyling.BORDER_NONE;
  }

  const ElementLabel = document.querySelectorAll('#okta-sign-in .authenticator-verify-list .authenticator-description .authenticator-label--small');
  if (ElementLabel) {
    ElementLabel.forEach(el => {
      if (!el.innerHTML.includes(':')) {
        el.innerHTML += ':';
      }
    });
  }

  const phoneElement = document.querySelector('#okta-sign-in.auth-container .mfa-okta-phone');
  if (phoneElement) {
    phoneElement.style.backgroundImage = `url(${phoneIcon})`;
    phoneElement.style.border = CommonOktaStyling.BORDER_NONE;
  }

  const emailAndPhoneText = document.querySelectorAll("#okta-sign-in .authenticator-verify-list .authenticator-description--text");
  if (emailAndPhoneText) {
    emailAndPhoneText.forEach((el, index) => {
      el.classList.add(classess.textSizeSM);
    });
  }

  const emailTextEle = document.querySelector('#okta-sign-in .siw-main-view .siw-main-body .identifier');
  if(emailTextEle){
    const emailMethod = document.querySelector("#okta-sign-in .authenticator-verify-list .authenticator-description--text");
    if(emailMethod){
      emailMethod.textContent = maskEmail(emailTextEle.textContent);
    }
    emailTextEle.textContent = maskEmail(emailTextEle.textContent);
  }
}